import avatar from "../../../assets/images/avatar.webp";
import { BsThreeDots } from "react-icons/bs";

import approveBtn from "../../../assets/images/yes.png";
import declineBtn from "../../../assets/images/No.png";

import noApproveBtn from "../../../assets/images/YesBW.png";
import noDeclineBtn from "../../../assets/images/NoBW.png";

import { capitalizeWords } from "../../../components/Reusable/capitalizeWords";
import formatDate from "../../../components/Reusable/dateUtils";

import {
  getStatusColor,
  getStatusText,
  isLeaveProcessed,
  truncateemployeeName,
} from "../leaveManagementFunctions";

export default function LeaveTableRow({
  employee,
  loggedEmployeeId,
  activeMenuId,
  menuPosition,
  handleToggleMenu,
  handleLeaveMoreDetails,
  handleUpdateLeaveDetails,
  handleLeaveApprove,
  handleLeaveDecline,
}) {
  return (
    <tr id={employee.leave_id}>
      <td className="leave_empImage">
        <img src={employee?.user?.profile_picture || avatar} alt="Employee" />
      </td>
      <td className="leave_empDetails">
        <div className="tooltip-container">
          <span className="tooltip-text">
            {employee?.user?.employee_full_name}
          </span>
        </div>
        <span>
          {capitalizeWords(
            truncateemployeeName(employee?.user?.employee_full_name),
          )}
        </span>

        <div className="leave_designation">
          <span style={{ fontSize: "10px" }}>
            {employee?.user?.roles[0]?.role_name}
          </span>
        </div>
        <div className="leave_id">
          <span style={{ fontSize: "10px" }}>
            ID:{employee?.user?.employee_id}
          </span>
        </div>
      </td>
      <td style={{ fontSize: "12px" }}>{formatDate(employee.apply_date)}</td>
      <td style={{ fontSize: "12px" }}>{formatDate(employee.leave_from)}</td>
      <td style={{ fontSize: "12px" }}>{formatDate(employee.leave_to)}</td>
      <td style={{ fontSize: "12px" }}>
        {employee.days_count} {employee.days_count > 1 ? "Days" : "Day"}
      </td>
      <td style={{ fontSize: "12px" }}>{employee.leave_type}</td>
      <td style={{ color: getStatusColor(employee, loggedEmployeeId) }}>
        {getStatusText(employee, loggedEmployeeId)}
      </td>
      <td style={{ fontSize: "12px" }}>
        {isLeaveProcessed(employee, loggedEmployeeId) ? (
          <>
            <button
              className="btn btn-approve"
              onClick={() => handleLeaveApprove(employee.leave_id)}
            >
              <img src={noApproveBtn} alt="approve" />
            </button>
            <button
              type="button"
              className="btn btn-decline"
              onClick={() => handleLeaveDecline(employee.leave_id)}
            >
              <img src={noDeclineBtn} alt="decline" />
            </button>
          </>
        ) : (
          <>
            <button
              className="btn btn-approve"
              onClick={() => handleLeaveApprove(employee.leave_id)}
            >
              <img src={approveBtn} alt="approve" />
            </button>
            <button
              type="button"
              className="btn btn-decline"
              onClick={() => handleLeaveDecline(employee.leave_id)}
            >
              <img src={declineBtn} alt="decline" />
            </button>
          </>
        )}
      </td>
      <td style={{ fontSize: "12px" }}>
        <span
          className="leave_icon-dots"
          onClick={(e) => handleToggleMenu(employee.leave_id, e)}
        >
          <BsThreeDots />
        </span>
        <div
          className={`
    absolute right-6 top-[calc(100%+12px)] w-fit
    transition-all duration-300 ease-[cubic-bezier(0.16,1,0.3,1)]
    ${
      activeMenuId === employee.leave_id
        ? "opacity-100 scale-100 translate-y-0 visible"
        : "opacity-0 scale-95 -translate-y-2 invisible"
    }
  `}
          style={menuPosition}
          onClick={(e) => e.stopPropagation()}
        >
          <ul className="flex flex-col rounded-md border bg-white z-50 !gap-0 shadow-lg">
            <li
              className="border-b py-1 hover:bg-neutral-600 hover:text-white"
              onClick={() => handleLeaveMoreDetails(employee.leave_id)}
            >
              <button className="px-4 py-1.5 whitespace-nowrap text-sm font-semibold">
                View Details
              </button>
            </li>

            <li
              className="border-b py-1 hover:bg-neutral-600 hover:text-white"
              onClick={() => handleUpdateLeaveDetails(employee.leave_id)}
            >
              <button className="px-4 py-1.5 whitespace-nowrap text-sm font-semibold">
                Edit Leave
              </button>
            </li>
          </ul>
        </div>
      </td>
    </tr>
  );
}
